// Mobile PDP image gallery — iOS Photos pattern.
// Single hero image, swipe to advance, loops at the ends, dot indicator
// for image position. Switches to a 1/N counter when there are more than
// 8 images (dots become unreadable). Desktop is untouched.
//
// Active media wrapper is the one without the `.hide` class. We hide/show
// wrappers rather than animate-translate because that's how the theme's
// existing variant-image-swap and click-thumb logic already works — no
// risk of fighting other JS.

document.addEventListener('DOMContentLoaded', function () {
  var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  if (!isTouchDevice) return;

  var sections = document.querySelectorAll('[data-section-type="product"]');
  sections.forEach(function (section) {
    var mediaContainer = section.querySelector('.product-media');
    if (!mediaContainer) return;

    var frame = mediaContainer.querySelector('.frame') || mediaContainer;
    var mediaWrappers = Array.from(
      mediaContainer.querySelectorAll('[data-product-single-media-wrapper]')
    );
    if (mediaWrappers.length < 2) return;

    var total = mediaWrappers.length;
    var SHOW_DOTS_MAX = 8;
    var SWIPE_THRESHOLD = 45;

    // --- Inject dots + counter into the frame ------------------------------
    var dotsBar = document.createElement('div');
    dotsBar.className = 'product-media-dots';
    dotsBar.setAttribute('aria-hidden', 'true');
    if (total <= SHOW_DOTS_MAX) {
      for (var i = 0; i < total; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'product-media-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('data-dot-index', String(i));
        dot.setAttribute(
          'aria-label',
          'Show image ' + (i + 1) + ' of ' + total
        );
        dotsBar.appendChild(dot);
      }
    }
    frame.appendChild(dotsBar);

    var counter = document.createElement('div');
    counter.className = 'product-media-counter';
    counter.setAttribute('aria-hidden', 'true');
    counter.innerHTML =
      '<span data-counter-current>1</span>/<span data-counter-total>' + total + '</span>';
    frame.appendChild(counter);

    // --- State helpers -----------------------------------------------------
    function getCurrentIndex() {
      var idx = mediaWrappers.findIndex(function (w) {
        return !w.classList.contains('hide');
      });
      return idx === -1 ? 0 : idx;
    }

    function showIndex(target) {
      if (target < 0) target = total - 1;      // loop back to last
      if (target >= total) target = 0;          // loop to first
      var current = getCurrentIndex();
      if (target === current) return;
      mediaWrappers[current].classList.add('hide');
      mediaWrappers[target].classList.remove('hide');
      updateIndicators(target);
      section.dispatchEvent(
        new CustomEvent('product-media:change', { detail: { index: target } })
      );
    }

    function updateIndicators(idx) {
      var dots = dotsBar.querySelectorAll('[data-dot-index]');
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
      });
      var cur = counter.querySelector('[data-counter-current]');
      if (cur) cur.textContent = String(idx + 1);
    }

    // --- Dot taps ----------------------------------------------------------
    dotsBar.querySelectorAll('[data-dot-index]').forEach(function (dot) {
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var idx = parseInt(dot.getAttribute('data-dot-index'), 10);
        if (!isNaN(idx)) showIndex(idx);
      });
    });

    // --- Sync indicators when other code changes the active wrapper --------
    // (e.g. the haven variant picker swaps which wrapper is visible)
    var syncObserver = new MutationObserver(function () {
      updateIndicators(getCurrentIndex());
    });
    mediaWrappers.forEach(function (w) {
      syncObserver.observe(w, { attributes: true, attributeFilter: ['class'] });
    });

    // --- Touch swipe -------------------------------------------------------
    var startX = 0, startY = 0, lastX = 0, lastY = 0, isTracking = false;

    function handleTouchStart(e) {
      if (window.innerWidth > 768) return;
      var t = e.touches[0];
      startX = t.clientX; startY = t.clientY;
      lastX = startX; lastY = startY;
      isTracking = true;
    }
    function handleTouchMove(e) {
      if (!isTracking || window.innerWidth > 768) return;
      var t = e.touches[0];
      lastX = t.clientX; lastY = t.clientY;
    }
    function handleTouchEnd() {
      if (!isTracking || window.innerWidth > 768) { isTracking = false; return; }
      var dx = lastX - startX;
      var dy = lastY - startY;
      isTracking = false;
      if (Math.abs(dx) < Math.abs(dy)) return;
      if (Math.abs(dx) < SWIPE_THRESHOLD) return;
      var idx = getCurrentIndex();
      showIndex(dx < 0 ? idx + 1 : idx - 1);
    }
    mediaContainer.addEventListener('touchstart', handleTouchStart, { passive: true });
    mediaContainer.addEventListener('touchmove', handleTouchMove, { passive: true });
    mediaContainer.addEventListener('touchend', handleTouchEnd);
    mediaContainer.addEventListener('touchcancel', function () { isTracking = false; });
  });
});
